export const PAGE_TITLE = "IAIH Conferences";

export const INTRO_HTML =
  "The <b>International Association of Interpersonal Hypnotherapists (IAIH)</b> hosts annual conferences, both online and in person, to foster professional development and community engagement. These events offer opportunities for learning, networking, and staying updated on the latest advancements in hypnotherapy.<br/><br/>To learn more about our upcoming conference, please visit the IAIH website.";

export const LINK_BOX_TITLE = "IAIH website";

export const LINK_BOX_URL =
  "https://www.instituteofhypnotherapy.com/iaih-2025-conference-landing-page/";

export const BENEFITS_SECTION_TITLE =
  "Attending these conferences provides numerous benefits, including:";

export const BENEFITS = [
  {
    id: 1,
    html: "<b>Continuing Education:</b> Earn credits to maintain certifications and enhance your skills",
  },
  {
    id: 2,
    html: "<b>Networking:</b> Connect with peers, mentors, and industry leaders.",
  },
  {
    id: 3,
    html: "<b>Latest Insights:</b> Stay informed about new techniques, research, and best practices.",
  },
];

export const FOOTER_TEXT_ENCOURAGE =
  "We encourage all members and interested professionals to participate and contribute to the growth of our hypnotherapy community.";

export const FOOTER_TEXT_BREAKDOWN =
  "Attending professional conferences offers numerous benefits for personal and professional growth. These events provide opportunities to learn, network, and gain inspiration, making them valuable investments for anyone looking to advance in their field. Here's a breakdown of the key advantages:";
